import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {SharedService} from "../services/shared.service";

@Injectable({
  providedIn: 'root'
})
export class BackpackerAuthGuard {
  constructor(private router: Router, private settings: SharedService) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    if (!this.settings.employeeLogin || !this.settings.username) {
      this.router.navigate(['/login']);
      return false;
    } else {
      return true;
    }

  }

}
